module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAABGCAYAAADb7SQ4AAAAt0lEQVRoge3ZIW6CQRSF0dMJEjSOVcAC8KWshVqQYGELXUPBVzd0N4CvYJCkScPPmPvZN3nHPDcvw4+R2gwLTND32M44YosDlDpY4xPTDlB15xT7aunhFcsOsHst8V3w/kT01qJg3AAeFwwawIPy95tuChw4cODAgQMHDhw4cODAgQMHDhw4cODAgQMHDhw48H/hUwP3XPDTAD4W7BrAu+L6fb55IrrB/nZcK8zxhUsH2KXufquWX3YKF+MHo4y9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-green.png
// module id = 29
// module chunks = 0